<div *ngIf="priceCardConfig.isSmallCard" class="container">
  <div class="container__small">
    <p>{{ title }}</p>
    <div class="container__small-prices">
      <h6>{{ priceCardConfig.annualPrice | currency: "EUR":true }}</h6>
      <span *ngIf="priceCardConfig.isSmallCard">{{ year }}</span>
      <p *ngIf="priceCardConfig.isMediumCard">{{ priceSubtitle }}</p>
    </div>
  </div>
  <div class="container__text">
    <p>{{ subtitle }}{{ priceCardConfig.monthlyPrice | currency: "EUR":true }}{{ month }}</p>
  </div>
</div>

<div *ngIf="priceCardConfig.isCenteredCard">
  <div class="center-container">
    <p>Protegido por</p>

    <div class="price-container">
      <h4>{{ priceCardConfig.annualPrice | currency: "EUR":true }}</h4>
      <span>{{ year }}</span>
    </div>

    <p class="subtitle">{{ subtitle }}{{ priceCardConfig.monthlyPrice | currency: "EUR":true }}{{ month }}</p>
  </div>
</div>

<div class="xsell-section" *ngIf="priceCardConfig.isXsell">
  <div class="container-xsell">
    <p>{{ title }}</p>
  </div>
  <div class="container-small-prices-xsell">
    <h4>{{ priceCardConfig.annualPrice | number:'1.2-2' }}€</h4>
    <span>{{ year }}</span>
  </div>

</div>